import { Component, ElementRef, Inject, OnInit, ViewChild } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import html2canvas from 'html2canvas';
import jsPDF from 'jspdf';
import { NgxSpinnerService } from 'ngx-spinner';
import { HeaderService } from 'src/app/core/services/header.service';

@Component({
  selector: 'app-billing-preview',
  templateUrl: './billing-preview.component.html',
  styleUrls: ['./billing-preview.component.scss'],
})
export class BillingPreviewComponent implements OnInit {
  fullName: string = this.data.fullName;
  title: string = this.data.title;
  name: string = this.data.names;
  currentDate = new Date();
  fromDate = new Date(this.data.fromDate);
  toDate = new Date(this.data.toDate);
  period = this.data.period;
  consumptionType =
    this.data.type == '-1'
      ? 'Job, Session'
      : this.data.type == '0'
      ? 'Job'
      : 'Session';
  dataSource = this.data.consumptionData;
  displayedColumns: string[] = ['no', 'type', 'units', 'price', 'total'];
  summaryData: any[];
  isDownloading: boolean = false;
  @ViewChild('consumption') consumption!: ElementRef;

  constructor(
    public dialog: MatDialogRef<BillingPreviewComponent>,
    @Inject(MAT_DIALOG_DATA)
    public data: {
      consumptionData: any[];
      type: string;
      title: string;
      fromDate: string;
      toDate: string;
      period: string;
      names: string;
      fullName: string;
    },
    private snackBar: MatSnackBar,
    private headerService: HeaderService,
    private spinner: NgxSpinnerService
  ) {}

  ngOnInit(): void {
    this.groupConsumptionData();
  }

  onClose(): void {
    this.dialog.close();
  }

  groupConsumptionData() {
    let jobsData = this.data.consumptionData.filter((data) => data.type == '0');
    let sessionsData = this.data.consumptionData.filter(
      (data) => data.type == '1'
    );
    let data: any[] = [];
    if (jobsData.length > 0) {
      let totalJobsUnits = jobsData.reduce(
        (acc, data) => acc + data.totalUnits,
        0
      );
      let price = jobsData[0].pricePerUnit;
      let total = totalJobsUnits * price;
      data.push({
        type: 'Jobs',
        units: totalJobsUnits,
        price: `${jobsData[0].currency} ${price}`,
        total: `${jobsData[0].currency} ${total}`,
      });
    }
    if (sessionsData.length > 0) {
      let totalSessionsUnits = sessionsData.reduce(
        (acc, data) => acc + data.totalUnits,
        0
      );
      let price = sessionsData[0].pricePerUnit;
      let total = totalSessionsUnits * price;
      data.push({
        type: 'Sessions',
        units: totalSessionsUnits,
        price: `${jobsData[0].currency} ${price}`,
        total: `${jobsData[0].currency} ${total}`,
      });
    }
    this.summaryData = data;
  }

  getTotalCost() {
    let total = this.summaryData
      .map((t) => t.total.split(' ')[1])
      .reduce((acc, value) => acc + parseInt(value), 0);
    return `${this.data.consumptionData[0].currency} ${total}`;
  }

  // function to download html content as pdf
  downloadAsPDF() {
    const printContent = document.getElementById('consumption');
    const WindowPrt = window.open(
      '',
      '',
      'left=0,top=0,width=900,height=900,toolbar=0,scrollbars=0,status=0'
    );
    WindowPrt.document.write(printContent.innerHTML);
    WindowPrt.document.close();
    WindowPrt.focus();
    WindowPrt.print();
    WindowPrt.close();
  }

  async generatePdf() {
    this.snackBar.open("Please wait while PDF is generating. It may take few minutes.");
    const pdf = new jsPDF('p', 'mm', 'a4');
    this.spinner.show("consumption");
    for (let i = 1; i < 3; i++) {
      let content = this.consumption.nativeElement;

      // Get the full height of the scrollable content
      const contentHeight = content.scrollHeight;

      // Calculate the number of pages based on the content height and the PDF page height
      const pageHeight = content.clientHeight;
      const totalPages = Math.ceil(contentHeight / pageHeight);

      // Set the initial y position
      let currentPosition = 0;

      // Loop through each page and capture the content using html2canvas
      for (let i = 0; i < totalPages; i++) {
        // Scroll to the current position
        content.scrollTo(0, currentPosition);

        // Wait for a short delay to allow content to render properly
        // await new Promise((resolve) => setTimeout(resolve, 100));

        // Capture the current page as an image using html2canvas
        const canvas = await html2canvas(content);
        const imgData = canvas.toDataURL('image/png');

        // Add the image to the PDF
        if (i > 0) {
          pdf.addPage();
        }
        pdf.addImage(imgData, 'PNG', 10, 10, 190, 0);

        // Update the current position for the next page
        currentPosition += pageHeight;
      }
    }

    let fileName =
      'Consumption_Report_' +
      this.headerService.getUserNewDate().toISOString().slice(0, 10) +
      '-' +
      this.formatTime(this.headerService.getUserNewDate()) +
      '.pdf';
    pdf.save(fileName);

    this.snackBar.open(
      'Screen is captured, pdf will be downloaded soon.',
      'Ok',
      { duration: 2000 }
    );
    this.spinner.hide("consumption");
    this.dialog.close();
  }

  formatTime(date: Date): string {
    const hours = date.getHours().toString().padStart(2, '0');
    const minutes = date.getMinutes().toString().padStart(2, '0');
    const seconds = date.getSeconds().toString().padStart(2, '0');

    return `${hours}-${minutes}-${seconds}`;
  }
}
